import React from 'react';
import TabContainer from '../../../../../../../common/components/tab/containers/tab.containers';
import { EmailCampaignBasicInfoComponent } from './plans-basic-info.component';

export const EmailCampaignComponent = ({ AccountTypes,Accounts, 
    id,PolicyOwnerType, campaignFrequency, onFormItemChange, selectedPlans, 
    onInnerBasicFormChange, back, handleFormSubmit,tagNames ,handleSelectedTemplates}: any) => {

    const handleInnerMediaFormChange: any = ({ field, value }: any) => {
        onFormItemChange({
            value: value.MediaFiles,
            field: 'MediaFiles',
            idx: '', 
        });
    };
    const tabItems = [
        {
            id: 1,
            title: 'Basic-Info',
            component: (
                <EmailCampaignBasicInfoComponent
                    onInnerBasicFormChange={onInnerBasicFormChange}
                    selectedPlans={selectedPlans}
                    campaignFrequency={campaignFrequency}
                    PolicyOwnerType={PolicyOwnerType}
                    AccountTypes={AccountTypes}
                    Accounts={Accounts}
                    tagNames={tagNames}
                    handleSelectedTemplates={handleSelectedTemplates}
                />
            ),
            isVisible: true,
        },   
       
    ]
    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">
            <TabContainer tabItems={tabItems} />
            <div className='flex w-full justify-end items-end h-20'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}
                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    )
}
export default EmailCampaignComponent;
